import { TdcEvaluationResponse } from 'src/app/models/apis/tdc/tdc-evaluation.model';
import { TdcEvaluationResult } from 'src/app/models/tdc/tdc-evaluation.model';

export const getTdcEvaluationFrom = (
	tdcEvaluationResponse: TdcEvaluationResponse
): TdcEvaluationResult => {
	const { solicitudAprobada, motivoRechazo } = tdcEvaluationResponse;
	const hasAnyCardApprobed: boolean = solicitudAprobada;

	const declinedObservations: Array<string> = motivoRechazo
		? motivoRechazo.split(',')
		: [];

	return {
		hasAnyCardApprobed,
		rejectionObservations: declinedObservations,
	};
};
